import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'checkItemInArray' })
export class CheckItemInArrayPipe<T> implements PipeTransform {
  transform(masterlist: T[], value: T): boolean {
    if (masterlist != null && masterlist.length > 0) {
      return masterlist.indexOf(value) >= 0;
    }

    return false;
  }
}
